export default __webpack_public_path__ + "static/media/user-profile-icon.75086b41.svg";